import { EwasteStatus, PaymentStatus, ProfileStatus, RequestStatus, RewardTransactionStatus, UserDeleteRequestStatus } from 'src/enums/common';
import { ServiceTypeModel } from 'src/interfaces/masters/service/service';
import { BrandModel } from '../../interfaces/masters/base/brand';
import { CategoryModel } from '../../interfaces/masters/base/category';
import { ProductModel } from '../../interfaces/masters/base/product';
import { ModelMaster } from '../../interfaces/masters/ModelMaster/model';

// returns name of category, parameters: category object list & category Id
export const getCategoryNameById = (categories: CategoryModel[], id: string) : string => {
  if (categories) {
    const categoryName : CategoryModel = (categories.find(
      (category) => category.id === id
    ));

    return categoryName ? categoryName.name : '';
  }
  return '';
};

// returns name of product, parameters: product object list & product Id
export const getProductNameById = (products: ProductModel[], id: string) : string => {
  if (products) {
    const productName : ProductModel = (products.find(
      (product) => product.id === id
    ));

    return productName ? productName.name : '';
  }
  return '';
};

// returns arrays of productType, parameters: product object list & product Id
export const getProductTypeArrayById = (products: ProductModel[], id: string) : string[] => {
  if (products) {
    const productTypeArray : ProductModel = (products.find(
      (product) => product.id === id
    ));

    return productTypeArray ? productTypeArray.productType : [];
  }
  return [];
};

// returns name of brand, parameters: brand object list & brand Id
export const getBrandNameById = (brands: BrandModel[], id: string) : string => {
  if (brands) {
    const brandName : BrandModel = (brands.find(
      (brand) => brand.id === id
    ));

    return brandName ? brandName.name : '';
  }
  return '';
};

// returns type of services, parameters: servicesType object list & brand Id
export const getServiceNameById = (services: ServiceTypeModel[], id: string) : string => {
  if (services) {
    const serviceName: ServiceTypeModel = (services.find(
      (service) => service.id === id
    ));

    return serviceName ? serviceName.type : '';
  }
  return '';
};

// returns id of model, parameters: models object list &  modelNo
export const getModelByModelNo = (models: ModelMaster[], modelNo: string) : string => {
  if (models) {
    const model : ModelMaster = (models.find(
      (prod) => prod.modelNo === modelNo
    ));

    return model ? model.id : '';
  }
  return '';
};

// converts image to base 64
export const getBase64 = (fileI, cb) => {
  const reader = new FileReader();
  reader.readAsDataURL(fileI);
  reader.onload = () => {
    cb(reader.result);
  };
  reader.onerror = (error) => {
    console.error(error);
  };
};

// check for file extension
export const validateFileType = (name: string, validExtensions: string[]) => {
  const idxDot = name.lastIndexOf('.') + 1;
  const extFile = name.substr(idxDot, name.length).toLowerCase();
  let error = null;
  if (!validExtensions.includes(extFile)) {
    error = `Only ${validExtensions.toString()} files allowed`;
  }
  return error;
};

// return an array of objects contains all the values of array1 with respect to elements of array2
// array1 is of type object array, array2 is string array
// name is the object field name on which intersection should be done
export const intersectionArray = (array1: object[], array2: string[], name: string) => {
  const tempArray = [];
  array2.forEach((elementValue) => {
    array1.forEach((element) => {
      if (element[name] === elementValue) {
        tempArray.push(element);
      }
    });
  });
  return tempArray;
};

// return an array of objects which does not contain any values of array2
// with respect to elements of array1
// array1 is of type object array, array2 is string array
// name is the object field name on which we found disjoined values
export const disjoinArray = (array1: object[], array2: string[], name: string) => {
  const tempArray = [];
  array1.forEach((elementValue) => {
    let count = 0;
    array2.forEach((element) => {
      if (element !== elementValue[name]) {
        count += 1;
      }
    });
    if (count === array2.length) {
      tempArray.push(elementValue);
    }
  });
  return tempArray;
};

// this function return unique strings from an array with respect to key of an object
// in an array of object
export const getUniqueIds = (inputArray, key) => inputArray?.map((item) => item[key])
  .filter((value, index, self) => self.indexOf(value) === index);

export const getUniqueArrayOfObjects = (inputArray, key) => {
  const uniqueObjArray = [
    ...new Map(inputArray.map((item) => [item[key], item])).values(),
  ];
  return uniqueObjArray;
};

// return an array of objects contains all the values of array1 with respect to elements of array2
// array1 is of type object array, array2 is of type object array
// field is the object field name on which intersection should be done
export const arrayOfObjectsIntersection = (list1: object[], list2: object[], field: string) => {
  const result = [];

  for (let i = 0; i < list1.length; i++) {
    const item1 = list1[i];
    let found = false;
    for (let j = 0; j < list2.length && !found; j++) {
      found = item1[`${field}`] === list2[j][`${field}`];
    }
    if (found) {
      result.push(item1);
    }
  }
  return result;
};

// return an array of objects which does not contain any values of array2
// with respect to elements of array1
// array1 and array2 is of type object array
// field is the object field name on which we found disjoined values
export const arrayOfObjectsDisjoin = (list1: object[], list2: object[], field: string) => {
  const result = [];

  for (let i = 0; i < list1.length; i++) {
    const item1 = list1[i];
    let found = false;
    for (let j = 0; j < list2.length && !found; j++) {
      found = item1[`${field}`] === list2[j][`${field}`];
    }
    if (!found) {
      result.push(item1);
    }
  }
  return result;
};
// It will be refactored to make seperate function for payment status and request status
export const getStatusColor = (status) => {
  let color;
  switch (status) {
    case RequestStatus.OPEN:
      color = 'success.main';
      break;
    case RequestStatus.PENDING:
      color = '#b79813';
      break;
    case RequestStatus.ASSIGNED:
      color = 'purple';
      break;
    case RequestStatus.RESOLVED:
      color = 'blue';
      break;
    case RequestStatus.SCHEDULED:
      color = 'warning.main';
      break;
    case RequestStatus.COMPLETED:
      color = 'info.main';
      break;
    case RequestStatus.CANCELLED:
      color = 'error.main';
      break;
    case PaymentStatus.VERIFIED:
      color = 'success.main';
      break;
    case PaymentStatus.FAILED:
      color = 'error.main';
      break;
    case PaymentStatus.CREATED:
      color = 'warning.main';
      break;
    case PaymentStatus.REFUNDED:
      color = 'info.main';
      break;
    case PaymentStatus.PAID:
      color = 'success.main';
      break;
    case PaymentStatus.UNPAID:
      color = 'error.main';
      break;
    default:
      break;
  }
  return color;
};

// eWaste status color code
export const getEWasteStatusColor = (status) => {
  let color;
  switch (status) {
    case EwasteStatus.OPEN:
      color = 'success.main';
      break;
    case EwasteStatus.PICKED:
      color = 'blue';
      break;
    case EwasteStatus.SCHEDULED:
      color = 'warning.main';
      break;
    case EwasteStatus.COMPLETED:
      color = 'info.main';
      break;
    case EwasteStatus.CANCELLED:
      color = 'error.main';
      break;
    default:
      break;
  }
  return color;
};

// customer account delete request status color code
export const getCustomerAccountDeleteStatusColor = (status) => {
  let color;
  switch (status) {
    case UserDeleteRequestStatus.OPEN:
      color = 'success.main';
      break;
    case UserDeleteRequestStatus.DELETED:
      color = 'error.main';
      break;
    case UserDeleteRequestStatus.REVOKED:
      color = 'warning.main';
      break;
    default:
      break;
  }
  return color;
};

// technician profile status color code
export const getProfileStatusColor = (status) => {
  let color;
  switch (status) {
    case ProfileStatus.INCOMPLETE:
      color = 'error.main';
      break;
    case ProfileStatus.EXPIRED:
      color = 'error.main';
      break;
    case ProfileStatus.PENDING:
      color = 'success.main';
      break;
    case ProfileStatus.REJECTED:
      color = 'warning.main';
      break;
    case ProfileStatus.RESUBMIT:
      color = 'info.main';
      break;
    case ProfileStatus.REVOKED:
      color = 'info.main';
      break;
    case ProfileStatus.INVITED:
      color = 'purple';
      break;
    default:
      break;
  }
  return color;
};

// payment status color code
export const getPaymentStatusColor = (status) => {
  let color;
  switch (status) {
    case PaymentStatus.VERIFIED:
      color = 'success.main';
      break;
    case PaymentStatus.FAILED:
      color = 'error.main';
      break;
    case PaymentStatus.CREATED:
      color = 'warning.main';
      break;
    case PaymentStatus.REFUNDED:
      color = 'info.main';
      break;
    case PaymentStatus.CANCELLED:
      color = 'error.main';
      break;
    case PaymentStatus.PAID:
      color = 'success.main';
      break;
    case PaymentStatus.UNPAID:
      color = 'error.main';
      break;
    default:
      break;
  }
  return color;
};

// Reward Transaction color code
export const getRewardTransactionStatusColor = (status) => {
  let color;
  switch (status) {
    case RewardTransactionStatus.COMPLETED:
      color = 'success.main';
      break;
    case RewardTransactionStatus.FAILED:
      color = 'error.main';
      break;
    case RewardTransactionStatus.PENDING:
      color = 'warning.main';
      break;
    case RewardTransactionStatus.CANCELLED:
      color = 'error.main';
      break;
    default:
      break;
  }
  return color;
};

export const getTotalTaxes = (sellingPrice: any, igst: any) => {
  if (sellingPrice && igst >= 0) {
    return ((igst / 100) * sellingPrice).toFixed(2);
  }
  return 0;
};
